import React from "react";
import { Link } from "react-router-dom";

export default function EconomicOpportunitySection({ api }) {
  const track = "economic-opportunity";
  const t = api?.t || {};
  const lang = api?.lang || "en";
  const cfg = t?.programTracks?.economicOpportunity || {};

  const returnTo = "/?noIntro=1#economic-opportunity-intake";

  const heading = cfg.heading || "Economic Opportunity & Financial Empowerment";
  const startIntake = cfg.startIntake || "Start intake";
  const blurb = cfg.blurb || "Build financial stability, learn how to access capital responsibly, and grow long-term wealth. WOW50/50 supports budgeting, credit tools, savings plans, and small-business readiness.";
  const helpTitle = cfg.helpTitle || "How we can help";
  const helpBullets = Array.isArray(cfg.helpBullets) && cfg.helpBullets.length ? cfg.helpBullets : ["Financial wellness coaching (budgeting, savings plans, debt strategy).", "Credit-building guidance and tools (education + next steps).", "Access-to-capital education (loan readiness, documents, lender navigation).", "Small business readiness (pricing, bookkeeping basics, digital presence).", "Community wealth-building pathways and referrals."];
  const trackLabel = cfg.trackLabel || "Economic Opportunity";
  const partnersTitle = cfg.partnersTitle || "For financial partners & community programs";
  const partnersBody1 = cfg.partnersBody1 || "We focus on measurable progress: education, action steps, and follow-through — so people can move from crisis to stability and growth.";
  const partnersBody2 = cfg.partnersBody2 || "Partner with WOW50/50 to support community wealth-building and small-business readiness.";

  const options = Array.isArray(cfg.options) && cfg.options.length
    ? cfg.options
    : [
        { id: "budgeting", label: "Budgeting / savings plan" },
                { id: "credit", label: "Credit building guidance" },
                { id: "access-to-capital", label: "Access to capital education" },
                { id: "business-support", label: "Small business readiness" },
                { id: "partnerships", label: "Partner / sponsor support" }
      ];

  return (
    <section id="economic-opportunity" className="scroll-mt-24 space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
          {heading}
        </h2>

        <Link
          to={`/intake?track=${encodeURIComponent(track)}&return=${encodeURIComponent(returnTo)}&lang=${encodeURIComponent(lang)}`}
          className="ml-auto inline-flex items-center justify-center rounded-full border border-emerald-400/30 bg-emerald-500/10 px-4 py-2 text-sm font-semibold text-emerald-200 hover:bg-emerald-500/15 transition"
        >
          {startIntake}
        </Link>
      </div>

      <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6 space-y-4">
        <p className="text-sm sm:text-base text-slate-200 max-w-4xl">
          {blurb}
        </p>

        <div className="grid gap-3 md:grid-cols-2">
          <div id="economic-opportunity-intake" className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
            <div className="text-sm font-semibold text-slate-100">{helpTitle}</div>
            <ul className="mt-2 list-disc pl-5 text-sm text-slate-200 space-y-1">
              {helpBullets.map((b, idx) => (
                <li key={idx}>{b}</li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
            <div className="text-sm font-semibold text-slate-100">{partnersTitle}</div>
            <div className="mt-2 text-sm text-slate-200 space-y-2">
              <p>{partnersBody1}</p>
              <p>{partnersBody2}</p>
            </div>
          </div>
        </div>
      </div>
    
      <div className="mt-6 rounded-2xl border border-slate-800 bg-[#010916]/70 p-4">
        <div className="text-sm font-semibold text-slate-100">Member Intake (required)</div>
        <p className="mt-1 text-xs text-slate-300">
          To request personalized support under this program, you must be an active WOW50/50 member and logged in.
        </p>
        <div className="mt-3">
          <Link
            to={"/intake?track=" + encodeURIComponent(track)}
            className="inline-flex items-center justify-center rounded-xl border border-cyan-400/40 bg-cyan-500/10 px-4 py-2 text-sm font-semibold text-cyan-200 hover:bg-cyan-500/15"
          >
            Go to Member Intake
          </Link>
        </div>
      </div>
</section>
  );
}
